import { Fragment } from 'react'

type PostTableProps = {
  items: {
    columns: string[]
    rows: React.ReactNode[][]
  }
}

export default function PostTable({ items }: PostTableProps): JSX.Element {
  const { columns, rows } = items || {}

  if (!columns || !rows) {
    return null
  }

  return (
    <div className="table-wrap custom-table">
      <div className="rounded-lg">
        <div className="table-scroll">
          <table className="jf-table">
            <thead className="jf-table__header">
              <tr className="jf-table__row">
                {items.columns.map((column) => {
                  return (
                    <th
                      className={`jf-table__cell jf-table__cell--${column}`}
                      key={`column-${column.toLowerCase()}`}>
                      {column}
                    </th>
                  )
                })}
              </tr>
            </thead>

            <tbody className="jf-table__body">
              {items.rows.map((row, rowIndex) => (
                <tr key={rowIndex} className="jf-table__row text-17 text-grey-950">
                  {row.map((cell, cellIndex) => (
                    <Fragment key={cellIndex}>
                      {cell ? <td className="jf-table__cell">{cell}</td> : null}
                    </Fragment>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
